export const RISK_WEIGHTS = { m: 2, d: 2, f: 2 };

export const MAX_MEASUREMENTS = {
  maxDensity: 5,
  maxMood: 1,
  maxFlow: 5,
};
